module.exports = __webpack_public_path__ + "static/img/h3-3.525e277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h3-3.png
// module id = D+Hc
// module chunks = 1